import { environment } from '@env/environment';

declare global {
  interface Window {
    markerConfig?: {
      project: string;
      source: string;
    };
    __Marker?: any;
    Marker?: any;
  }
}

export class MarkerTracker {
  static init() {
    if (environment.markerConfig) {
      console.log('[MarkerTracker] Initializing with project:', environment.markerConfig.project);

      // Set marker config
      window.markerConfig = {
        project: environment.markerConfig.project,
        source: environment.markerConfig.source,
      };

      // Initialize Marker.io
      if (!window.__Marker) {
        window.__Marker = {};
        const commands: any[] = [];
        const api: any = { __cs: commands };

        [
          'show',
          'hide',
          'isVisible',
          'capture',
          'cancelCapture',
          'unload',
          'reload',
          'isExtensionInstalled',
          'setReporter',
          'clearReporter',
          'setCustomData',
          'on',
          'off',
        ].forEach(method => {
          api[method] = function (...callArgs: unknown[]) {
            commands.push([method, ...callArgs]);
          };
        });

        window.Marker = api;

        // Load the Marker.io script
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://edge.marker.io/latest/shim.js';
        script.onload = () => {
          console.log('[MarkerTracker] Marker.io script loaded successfully');
        };
        script.onerror = () => {
          console.error('[MarkerTracker] Failed to load Marker.io script');
        };
        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode?.insertBefore(script, firstScript);

        console.log('[MarkerTracker] Marker.io initialization complete');
      } else {
        console.log('[MarkerTracker] Marker.io already initialized');
      }
    } else {
      console.log('[MarkerTracker] No markerConfig found in environment');
    }
  }
}
